<template>
  <div class="pincode">
    <PinInputElement v-model="code1" id="code1" @paste="onPaste" />
    <PinInputElement v-model="code2" id="code2" @paste="onPaste" />
    <PinInputElement v-model="code3" id="code3" @paste="onPaste" />
    <PinInputElement v-model="code4" id="code4" @paste="onPaste" />
    <PinInputElement v-model="code5" id="code5" @paste="onPaste" />
    <PinInputElement v-model="code6" id="code6" @paste="onPaste" />
  </div>
</template>

<script setup lang="ts">
import PinInputElement from '@/components/PinInputElement.vue'
import { computed, type ComputedRef, ref, type Ref, watch } from 'vue'

// modèle
const model = defineModel<string>({ required: true })

// données
const code1: Ref<string | null> = ref(null)
const code2: Ref<string | null> = ref(null)
const code3: Ref<string | null> = ref(null)
const code4: Ref<string | null> = ref(null)
const code5: Ref<string | null> = ref(null)
const code6: Ref<string | null> = ref(null)

// computed
const completeCode: ComputedRef<string> = computed(() =>
  [code1.value, code2.value, code3.value, code4.value, code5.value, code6.value].join(''),
)
const valideCode: ComputedRef<boolean> = computed(() => model.value.length === 6)

// fonctions
function onPaste(code: string) {
  code1.value = code[0] || null
  code2.value = code[1] || null
  code3.value = code[2] || null
  code4.value = code[3] || null
  code5.value = code[4] || null
  code6.value = code[5] || null
  document.getElementById('code6')?.focus()
}

watch(completeCode, () => (model.value = completeCode.value))

defineExpose({ valideCode })
</script>
